import React, { useMemo } from 'react';
import styles from './QuestionnaireResultsWithScoringListItem.module.scss';
import { QuestionnaireResult } from '../../../../../graphql/graphql';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import FormattedMomentDate, {
	DateFormat,
} from '../../../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import { useDisclose } from '../../../../Modal/Hooks/useDisclose';
import QuestionnaireResultWithScoringDetailModal from '../QuestionnaireResultWithScoringDetail/QuestionnaireResultWithScoringDetailModal';
import QuestionnaireResultsWithScoringListItemDetailedScoringModal from '../QuestionnaireResultsWithScoringListItemDetailedScoring/QuestionnaireResultsWithScoringListItemDetailedScoringModal';
import LinkButton from '../../../../../Components/Button/LinkButton';
import {
	ACER_SCORE_LEVEL_COLORS,
	getAcerScoreLevel,
	getAcerScorePercent,
	getAcerTotalMaxScore,
} from '../Helpers/QuestionnaireResultsWithScoringListItem.helper';

interface Props {
	item: QuestionnaireResult;
	onSubmitScore: () => void;
}

const QuestionnaireResultsWithScoringListItem: React.FC<Props> = ({
	item,
	onSubmitScore,
}) => {
	const { isOpen, onOpen, onClose } = useDisclose();
	const {
		isOpen: isOpenScoring,
		onOpen: onOpenScoring,
		onClose: onCloseScoring,
	} = useDisclose();

	const totalMaxScore = useMemo(() => getAcerTotalMaxScore(), []);

	const totalPercent = useMemo(
		() => getAcerScorePercent(item.score, totalMaxScore),
		[item.score, totalMaxScore],
	);

	const totalScoreBackgroundColor =
		ACER_SCORE_LEVEL_COLORS[getAcerScoreLevel(totalPercent)];

	const handleOnSubmitScore = () => {
		onClose();
		onSubmitScore();
	};

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.content}>
					<div className={styles.date}>
						<FormattedMomentDate
							date={item.createdAt}
							format={DateFormat.DATE_TIME}
						/>
					</div>
					<div className={styles.name}>{item.user?.profile?.fullName}</div>
					<div className={styles.title}>{item.questionnaire?.title}</div>
				</div>
				<div className={styles.scoring}>
					<div
						className={styles.score}
						style={{
							backgroundColor: totalScoreBackgroundColor,
						}}>
						{item.score}/{totalMaxScore}
					</div>
				</div>
				<div className={styles.controls}>
					<Button title='Bodovat' theme={Theme.GREEN} onClick={onOpen} />

					<LinkButton
						title='Podrobné výsledky'
						theme={Theme.BLUE}
						onClick={onOpenScoring}
					/>
				</div>
			</div>

			{isOpen && (
				<QuestionnaireResultWithScoringDetailModal
					isOpen
					onClose={onClose}
					item={item}
					onSubmit={handleOnSubmitScore}
				/>
			)}

			{isOpenScoring && (
				<QuestionnaireResultsWithScoringListItemDetailedScoringModal
					isOpen
					onClose={onCloseScoring}
					item={item}
				/>
			)}
		</>
	);
};

export default QuestionnaireResultsWithScoringListItem;
